import gdprService from 'services/gdprService'
import * as actionTypes from '../actions/actionTypes'

export const fetchingPrivacyPolicy = () =>{
  return dispatch =>{
    gdprService.getPrivacyPolicy()
    .then( data => {
      fetch(data.path)
      .then((res) => res.text())
      .then(privacyContent => dispatch(successFetchingPrivacyPolicy(privacyContent)))
    })
    .catch(err =>{
      console.log(err)
    })
  }
}

const successFetchingPrivacyPolicy = privacyPolicy => {
  return {
    type: actionTypes.GDPR_SUCCESS_PRIVACY_POLICY,
    privacyPolicy : privacyPolicy
  }
}

export const fetchingTermsConditions = () => {
  return dispatch => {
     gdprService.getTermsConditions()
     .then(data => {
        fetch(data.path)
        .then((res) => res.text())
        .then(termsConditionsContent => dispatch(successFetchingTermsConditions(termsConditionsContent)))
     })
     .catch(err =>{
       console.log(err)
     })
  }
}


const successFetchingTermsConditions = termsConditions => {
  return {
    type: actionTypes.GDPR_SUCCESS_TERMS_CONDITIONS,
    termsConditions : termsConditions
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/Gdpr.js